import { Badge } from '@agrotoken-tech/ui';
import { clientDossierStatusGeneralBadgeColors } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { useUserContext } from '../../contexts/UserContext';
import { DigitalDossierSectionProvider } from './context/DigitalDossierSectionContext';
import useDigitalDossier from './hooks/useDigitalDossier';
import { DigitalDossierLayout } from './shared/DigitalDossierLayout';

const DigitalDossierWrapper = () => {
  const { theme, tabsData, digitalDossierStatus } = useDigitalDossier();
  const { t } = useTranslation();
  const { user, userHasPendingChanges, setUserHasPendingChanges } =
    useUserContext();

  return (
    <DigitalDossierLayout
      theme={theme}
      tabsData={tabsData}
      title={user.companyName}
      badge={
        <>
          {digitalDossierStatus?.dossierStatus.digitalDossierStatuses.map(
            (status) => (
              <Badge
                key={status}
                colorScheme={clientDossierStatusGeneralBadgeColors[status]}
                mr="2"
              >
                {t(`accessRequests.status.digitalDossierStatus.${status}`)}
              </Badge>
            ),
          )}
        </>
      }
      hasUserPendingChanges={userHasPendingChanges}
      setUserHasPendingChanges={setUserHasPendingChanges}
    />
  );
};

export const DigitalDossier = () => {
  return (
    <DigitalDossierSectionProvider>
      <DigitalDossierWrapper />
    </DigitalDossierSectionProvider>
  );
};
